export default "__VITE_ASSET__Bc8T2hWa__"